export default "__VITE_ASSET__DhACNpCY__"